import { GALERIA } from "../data/content";

// Proporción real de cada foto (ancho/alto en px) para que el marco encaje
// exacto con la imagen — así no queda ni recortada ni con barras negras.
const RATIOS = ["1280/1184", "1280/960", "1280/916", "1280/1230"];

export const Galeria = () => {
    return (
        <section
            id="galeria"
            data-testid="galeria-section"
            className="relative py-24 md:py-32"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-10">
                <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
                    <div>
                        <div className="mb-6 inline-flex items-center gap-3">
                            <span className="h-px w-12 bg-gold" />
                            <span className="text-xs font-semibold uppercase tracking-[0.35em] text-gold">
                                Galería
                            </span>
                        </div>
                        <h2 className="font-display text-4xl leading-tight text-foreground sm:text-5xl md:text-6xl">
                            Nuestras
                            <span className="text-gold"> serenatas.</span>
                        </h2>
                    </div>
                    <p className="max-w-md text-muted-foreground md:text-right">
                        Un recorrido visual por los momentos más emocionantes que hemos
                        tenido el honor de acompañar.
                    </p>
                </div>

                {/* Fotos completas, en su proporción real — sin recorte, sin barras y sin texto */}
                <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 md:gap-8">
                    {GALERIA.map((src, i) => (
                        <figure
                            key={src}
                            data-testid={`galeria-item-${i}`}
                            style={{ aspectRatio: RATIOS[i] }}
                            className="group relative overflow-hidden rounded-3xl border border-gold/20 bg-card shadow-[0_20px_50px_-20px_rgba(0,0,0,0.6)] transition-all duration-500 hover:border-gold/50 hover:shadow-[0_25px_60px_-20px_hsl(var(--gold)/0.35)]"
                        >
                            <img
                                src={src}
                                alt="Mariachi Mexicanísimo en un evento real"
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                            />
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Galeria;
